module.exports = __webpack_public_path__ + "static/media/logo.674de013.png";